import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import LogRocket from 'logrocket';
// --- external imports ------

import { UserProvider } from '~/authentication'


import * as serviceWorker from './serviceWorker';
import App from './App';
import GTMProvider from './analytics/GTMProvider';
import LogRocketProvider from './analytics/LogrocketProvider';
// --- local imports ------


const tradersTracesSampleRate =
	process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging'
		? 0.25
		: 1.0;

Sentry.init({
		dsn: process.env.REACT_APP_SENTRY_DSN,
		integrations: [new Integrations.BrowserTracing()],
		tracesSampleRate: tradersTracesSampleRate,
		environment: process.env.NODE_ENV
	});

	if (process.env.REACT_APP_HEAP_APP_ID && window.heap) {
		window.heap.load(process.env.REACT_APP_HEAP_APP_ID);
	} else if (window.heap) {
		const fns = ["init","startTracking","stopTracking","track","resetIdentity","identify","identifyHashed","getSessionId","getUserId","getIdentity","addUserProperties","addEventProperties","removeEventProperty","clearEventProperties","addAccountProperties","addAdapter","addTransformer","addTransformerFn","onReady","addPageviewProperties","removePageviewProperty","clearPageviewProperties","trackPageview"];
		for (let p = 0; p < fns.length; p++) { window.heap[fns[p]] = function() {}; }
		console.log('Heap is disabled in this environment.');
	}

	export const root = ReactDOM.createRoot(document.getElementById('root'))
	root.render(
	<React.StrictMode>
		<UserProvider>
			<LogRocketProvider>
				<GTMProvider>
					<App />
				</GTMProvider>
			</LogRocketProvider>
		</UserProvider>
	</React.StrictMode>,
	);
	
	// If you want your app to work offline and load faster, you can change
	// unregister() to register() below. Note this comes with some pitfalls.
	// Learn more about service workers: https://bit.ly/CRA-PWA
	serviceWorker.unregister();
